import { render, staticRenderFns } from "./CoIcon.vue?vue&type=template&id=858f8df8&"
import script from "./CoIcon.vue?vue&type=script&lang=ts&"
export * from "./CoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CoIcon.vue?vue&type=style&index=0&id=858f8df8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports